import { render, staticRenderFns } from "./IconCommunity.vue?vue&type=template&id=35b07606&scoped=true"
import script from "./IconCommunity.vue?vue&type=script&lang=js"
export * from "./IconCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b07606",
  null
  
)

export default component.exports